import React from 'react';
import LeftBanner from './LeftBanner';
import RightBanner from './RightBanner';
import BackgroundAnimation from './BackgroundAnimation';

const Banner = () => {
  return (
    <section
      id="home"
      className="relative w-full min-h-screen font-titleFont flex items-center justify-center pt-[80px]"
    >
      <BackgroundAnimation />
      <div className="relative z-10 max-w-screen-xl mx-auto px-4 w-full flex flex-col xl:flex-row items-center justify-center gap-6 xl:gap-0 py-10 xl:py-0 xl:h-screen">
        <LeftBanner />
        <RightBanner />
      </div>
    </section>
  );
}

export default Banner;